import { red } from '@material-ui/core/colors';

export default () => ({
  editButton: { marginRight: '4px' },
  rolesTypography: { cursor: 'pointer' },
  error: { color: red[500] },
  listRoot: { minWidth: 250 },
  footer: {
    textAlign: 'right',
    padding: '1rem',
  },
  userChip: {
    marginBottom: '1rem',
    fontSize: '.75rem',
    fontWeight: 500,
  },
  chipIcon: { fontSize: '1.5em' },
  right: { textAlign: 'right' },
  passiveActiveSwitch: { width: '100%' },
});
